import type Controller from '@ember/controller';
import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelSettingsUsersPropertyAccessController from 'lumen/controllers/hotel/settings/users/property-access';
import type Userhotelrelationship from 'lumen/models/userhotelrelationship';
import type { Transition } from 'lumen/services/transition';

export interface PropertyAccessModel {
  relationships: Userhotelrelationship[];
  totalResults: number;
}

interface RouteParams {
  product?: string;
  role?: string;
  userEmail?: string;
  userId?: string;
}

export default class HotelSettingsUsersPropertyAccessRoute extends Route {
  queryParams = {
    userId: { refreshModel: true },
    userEmail: { refreshModel: false },
    role: { refreshModel: false },
    product: { refreshModel: false },
  };

  @service declare router: Services['router'];
  @service declare store: Services['store'];

  beforeModel(transition: Transition): void {
    const userId = transition.to?.queryParams?.['userId'];

    if (!userId) {
      this.router.transitionTo('hotel.settings.users');
    }
  }

  async model(params: RouteParams): Promise<PropertyAccessModel> {
    const results = await this.store.query('userhotelrelationship', {
      user_id: params.userId,
      page: 0,
      ...(params.role ? { role: params.role } : {}),
      ...(params.product ? { product: params.product } : {}),
    });

    const meta = results.meta as { results_count: number };

    return {
      relationships: results.slice() as unknown as Userhotelrelationship[],
      totalResults: meta.results_count,
    };
  }

  setupController(controller: Controller, model: PropertyAccessModel): void {
    super.setupController(controller, model);

    (
      controller as HotelSettingsUsersPropertyAccessController
    ).initializeFromModel();
  }
}
